export default {
      id: "logout-usage",
      viewBox: "0 0 446.26 512",
      url: __webpack_public_path__ + "img/svg-sprite.svg#logout",
      toString: function () {
        return this.url;
      }
    }